import { useCallback } from 'react';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import useUserInfo from 'framework-listing-lib/internal/hooks/useUserInfo';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { useCurrentUIMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import { useAllViews, useViewUpdateState, useViewColumns, useNumberOfFrozenColumns, useCardProperties, useCurrentView, useFiltersForNewViews, useQuickFilterPropertyNamesState } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import { useFilterGroups, useHiddenFilter } from 'framework-listing-lib/hooks/useListingLibFilters';
import useQuickFilters from 'framework-listing-lib/hooks/useQuickFilters';
import { convertViewToViewRequest, getViewWithNewFilters } from '../utils/mapper';
export default function useViewForm() {
  const {
    userInfo
  } = useUserInfo();
  const hiddenFilter = useHiddenFilter();
  const {
    filters
  } = useCrmObjectTypeListingFilters();
  const objectType = useObjectTypeId();
  const [viewUpdateState] = useViewUpdateState();
  const views = useAllViews();
  const columns = useViewColumns();
  const numberOfFrozenColumns = useNumberOfFrozenColumns();
  const currentUIMode = useCurrentUIMode();
  const filterGroups = useFilterGroups();
  const quickFilters = useQuickFilters();
  const cardProperties = useCardProperties();
  const currentView = useCurrentView();
  const filtersForNewViews = useFiltersForNewViews();
  const quickFilterPropertyNames = useQuickFilterPropertyNamesState();
  return useCallback(type => {
    const userId = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.user_id) || -1;
    const isFirstUserView = views.some(view => view.ownerId === userId) === false;
    let viewRequest = convertViewToViewRequest({
      cardProperties,
      columns,
      currentUIMode,
      filterGroups,
      hiddenFilter,
      numberOfFrozenColumns,
      objectType,
      quickFilters,
      quickFilterPropertyNames,
      sort: filters.sort,
      view: type === 'UPDATE' ? currentView : undefined,
      viewUpdateState
    });
    if (type === 'CLONE_WITH_CHANGES') {
      var _currentView$name;
      viewRequest.name = (_currentView$name = currentView === null || currentView === void 0 ? void 0 : currentView.name) !== null && _currentView$name !== void 0 ? _currentView$name : '';
    }
    /**
     * When creating a view for the first time:
     *   - set view name to "Usernames's first view"
     *   - set view as private
     */
    if (isFirstUserView) {
      viewRequest.name = userInfo !== null && userInfo !== void 0 && userInfo.user ? I18n.text('frameworkListingLib.viewTabs.modal.create.firstViewName', {
        username: I18n.SafeString(formatName({
          firstName: userInfo.user.first_name,
          lastName: userInfo.user.last_name
        }))
      }) : viewRequest.name;
      viewRequest.private = true;
    }
    if (type === 'CREATE_NEW') {
      viewRequest = getViewWithNewFilters({
        filtersForNewViews,
        viewRequest
      });
    }
    return viewRequest;
  }, [cardProperties, columns, currentUIMode, currentView, filterGroups, filters.sort, filtersForNewViews, hiddenFilter, numberOfFrozenColumns, objectType, quickFilterPropertyNames, quickFilters, userInfo === null || userInfo === void 0 ? void 0 : userInfo.user, viewUpdateState, views]);
}